import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	DoplnekMk: null as string | null,
	IbsKod: null as string | null,
	Text: null as string | null,
	Typkod: null as string | null,
	TypkodText: null as string | null,
	VerzeMk: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
	ZnackaovText: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.OJETE_VOZY_TYP_KOD_SELECT_MAPPER](state, { data }) {
			if (!data.isClear) {
				state.edit.VyrobekvozOzn = data.vyrobekvozozn;
			}
			state.edit.Typkod = data.typkod;
			state.edit.TypkodText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
